import React from 'react';
import { isEmpty } from 'lodash';
import { Badge } from '../ui-kit';

const getName = (group, fullName) => (!fullName && group.short_code ? group.short_code : group.name);

export const StationAndTeams = ({ station, teams, customStyles }) => {
  if (!teams || isEmpty(teams)) return station.name;

  return (
    <ul style={{ listStyle: 'none', padding: '0', margin: '0', ...customStyles }}>
      <li>{station.name}</li>
      <li>
        {teams.map(team => (
          <Badge key={team.id} style={{ marginRight: '2px', backgroundColor: team.color }}>
            {team.name}
          </Badge>
        ))}
      </li>
    </ul>
  );
};

// Renders the name of the team in the right color, and puts the station name in
// front of it. Example: "FSR Headquarters - Red", with "Red" as a red colored
// label
const GroupName = ({ group, parentGroup, fullName }) => {
  if (group.type === 'team') {
    const teamName = <Badge color={group.color}>{getName(group, fullName)}</Badge>;

    if (!parentGroup) return teamName;

    return (
      <>
        {getName(parentGroup, fullName)} {teamName}
      </>
    );
  } else {
    return getName(group, fullName);
  }
};

export default GroupName;
